import { Tag } from "antd";
import React from "react";

type PropsStateView = { name: string };

export const StateView: React.FC<PropsStateView> = ({ name }) => (
  <Tag color="gold">{name}</Tag>
);
